module.exports = __webpack_public_path__ + "img/logo.7bb8b71f.png";